import { createAction, props } from '@ngrx/store';

import { Status } from '@enums';
import {
  Address,
  BankingDetails,
  Document,
  Profile,
  User,
  UserBatch,
  UserCriminalRecordCheck,
  Vehicle,
} from '@models';

export const fetchUsers = createAction('[User] Fetch Users Initiated');
export const fetchUsersSuccess = createAction(
  '[User] Fetch Users Success',
  props<{ users: User[] }>()
);
export const fetchUsersFailed = createAction(
  '[User] Fetch Users Failed',
  props<{ error: Error }>()
);

// fetch user by id
export const fetchUserById = createAction(
  '[User] Fetch User By Id Initiated',
  props<{ userId: string }>()
);
export const fetchCurrentUser = createAction(
  '[User] Fetch Current User Initiated'
);
export const fetchUserByIdSuccess = createAction(
  '[User] Fetch User By Id Success',
  props<{ user: User }>()
);
export const fetchUserByIdFailed = createAction(
  '[User] Fetch User By Id Failed',
  props<{ error: Error }>()
);

// update user
export const updateUser = createAction(
  '[User] Update user',
  props<{ user: User }>()
);
export const updateUserSuccess = createAction(
  '[User] Update User Success',
  props<{ user: User }>()
);
export const updateUserFailed = createAction(
  '[User] Update User Failed',
  props<{ error: Error }>()
);

// set user profile status
export const setUserProfileStatus = createAction(
  '[User] Set User Profile Status',
  props<{ profile: Profile; status: Status }>()
);
export const setUserProfileStatusSuccess = createAction(
  '[User] Set User Profile Status Success',
  props<{ profile: Profile }>()
);
export const setUserProfileStatusFailed = createAction(
  '[User] Set User Profile Status Failed',
  props<{ error: Error }>()
);

// set user address status
export const setUserAddressStatus = createAction(
  '[User] Set User Address Status',
  props<{ address: Address; status: Status }>()
);
export const setUserAddressStatusSuccess = createAction(
  '[User] Set User Address Status Success',
  props<{ address: Address }>()
);
export const setUserAddressStatusFailed = createAction(
  '[User] Set User Address Status Failed',
  props<{ error: Error }>()
);

// set user document status
export const setUserDocumentStatus = createAction(
  '[User] Set User Document Status',
  props<{ document: Document; status: Status }>()
);
export const setUserDocumentStatusSuccess = createAction(
  '[User] Set User Document Success',
  props<{ document: Document }>()
);
export const setUserDocumentStatusFailed = createAction(
  '[User] Set User Document Failed',
  props<{ error: Error }>()
);

// set user banking details status
export const setUserBankingDetailsStatus = createAction(
  '[User] Set User Banking Details Status',
  props<{ bankingDetails: BankingDetails; status: Status }>()
);
export const setUserBankingDetailsStatusSuccess = createAction(
  '[User] Set User Banking Details Success',
  props<{ bankingDetails: BankingDetails }>()
);
export const setUserBankingDetailsStatusFailed = createAction(
  '[User] Set User Banking Details Failed',
  props<{ error: Error }>()
);

// set user banking details status
export const setUserVehicleStatus = createAction(
  '[User] Set User Vehicle Status',
  props<{ vehicle: Vehicle; status: Status }>()
);
export const setUserVehicleStatusSuccess = createAction(
  '[User] Set User Vehicle Success',
  props<{ vehicle: Vehicle }>()
);
export const setUserVehicleStatusFailed = createAction(
  '[User] Set User Vehicle Failed',
  props<{ error: Error }>()
);

// set user criminal record check status
export const setUserCriminalRecordCheckStatus = createAction(
  '[User] Set User Criminal Record Check Status',
  props<{ userCriminalRecordCheck: UserCriminalRecordCheck; status: Status }>()
);
export const setUserCriminalRecordCheckStatusSuccess = createAction(
  '[User] Set User Criminal Record Check Success',
  props<{ userCriminalRecordCheck: UserCriminalRecordCheck }>()
);
export const setUserCriminalRecordCheckStatusFailed = createAction(
  '[User] Set User Criminal Record Check Failed',
  props<{ error: Error }>()
);

// set map selected users
export const setSelectedMapUsers = createAction(
  '[User] Set Selected Map Users',
  props<{ users: any[] }>()
);

// Create CarTrack Profile
export const createCarTrackProfile = createAction(
  '[User] Create CarTrack Profile',
  props<{ user: User }>()
);
export const createCarTrackProfileSuccess = createAction(
  '[User] Create CarTrack Profile Success',
  props<{ user: User }>()
);
export const createCarTrackProfileFailed = createAction(
  '[User] Create CarTrack Profile Failed',
  props<{ error: Error }>()
);

// fetch Batch by id
export const fetchBatchById = createAction(
  '[User] Fetch Batch By Id Initiated',
  props<{ userBatchId: string }>()
);
export const fetchBatchByIdSuccess = createAction(
  '[User] Fetch Batch By Id Success',
  props<{ userBatch: UserBatch }>()
);
export const fetchBatchByIdFailed = createAction(
  '[User] Fetch Batch By Id Failed',
  props<{ error: Error }>()
);

// process Batch
export const processBatch = createAction(
  '[User] Process Batch Initiated',
  props<{ userBatchId: string }>()
);
export const processBatchSuccess = createAction('[User] Process Batch Success');
export const processBatchFailed = createAction(
  '[User] Process Batch Failed',
  props<{ error: Error }>()
);

// Fetch Batches
export const fetchBatches = createAction('[User] Fetch Batches Initiated');
export const fetchBatchesSuccess = createAction(
  '[User] Fetch Batches Success',
  props<{ userBatches: UserBatch[] }>()
);
export const fetchBatchesFailed = createAction(
  '[User] Fetch Batches Failed',
  props<{ error: Error }>()
);

// Create Batch
export const createBatch = createAction(
  '[User] Create Batch Initiated',
  props<{ file: File }>()
);
export const createBatchSuccess = createAction(
  '[User] Create Batch Success',
  props<{ userBatch: UserBatch }>()
);
export const createBatchFailed = createAction(
  '[User] Create Batch Failed',
  props<{ error: Error }>()
);
